/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { property } from 'lit/decorators.js';
import CDSModalCloseButton from '@carbon/web-components/es/components/modal/modal-close-button.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { EXPRESSIVE_MODAL_SIZE } from './defs';
import styles from './expressive-modal.scss';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Expressive modal close button.
 *
 * @element c4d-expressive-modal-close-button
 */
@customElement(`${c4dPrefix}-expressive-modal-close-button`)
class C4DExpressiveModalCloseButton extends StableSelectorMixin(
  CDSModalCloseButton
) {
  /**
   * The size variant.
   */
  @property({ reflect: true, attribute: 'size' })
  size = EXPRESSIVE_MODAL_SIZE.REGULAR;

  static get stableSelector() {
    return `${c4dPrefix}--expressive-modal-close-button`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DExpressiveModalCloseButton;
